export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
